<template>
  <div class="customernew">

    <h1>Kund- och anläggningsuppgifter</h1>
    <form @submit.prevent="submit" id="customernew-propertyinfo">
      <h2 class="customernew__block-title">Anläggningsuppgifter</h2>
      <div class="customernew__field-group customernew__propertyinfo">
        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">Adress <em>*</em></span>
          <input type="text" v-model="$root.address" class="customernew__field required" >
        </label>
        <label class="customernew__field-wrapper customernew__field-wrapper-third">
          <span class="customernew__field-label">Postnummer <em>*</em></span>
          <input type="text" v-model="$root.postal_code" class="customernew__field required" disabled="disabled" >
        </label>
        <label class="customernew__field-wrapper customernew__field-wrapper-third">
          <span class="customernew__field-label">Postort <em>*</em></span>
          <input type="text" v-model="$root.location" class="customernew__field required" >
        </label>

      </div>
      <div class="customernew__field-group customernew__propertyinfo">

        <label class="customernew__field-wrapper customernew__field-wrapper-third">
          <span class="customernew__field-label">Nätområdeskod (3 bokstäver, se din elnätsfaktura) <em>*</em></span>
          <input type="text" v-model="$root.territory_id" class="customernew__field required netareacode" />
        </label>

        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">Anläggnings-id (18-siffror, se din elnätsfaktura) <em>*</em></span>
          <input type="text" v-model="$root.construction_id" class="customernew__field required netpropertykey" placeholder="735 999 XXX XXX XXX XXX" />
        </label>

      </div>
      <!--<h2 class="customernew__block-title">Kunduppgifter</h2>-->
      <h2 class="customernew__block-title">Kontaktuppgifter</h2>
      <div class="customernew__field-group">
        <label class="customernew__field-wrapper customernew__field-wrapper-third">
          <span class="customernew__field-label">Personnummer <em>*</em></span>
          <input type="text" v-model="$root.personnummer" placeholder="ååååmmdd-xxxx" class="customernew__field required ssn" DISABLED="disabled">
        </label>
        <label class="customernew__field-wrapper customernew__field-wrapper-third">
          <span class="customernew__field-label">Förnamn <em>*</em></span>
          <input type="text" v-model="$root.name" class="customernew__field required" DISABLED="disabled">
        </label>
        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">Efternamn <em>*</em></span>
          <input type="text" v-model="$root.surname" class="customernew__field required" DISABLED="disabled">
        </label>
        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">E-postadress <em>*</em></span>

            <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => $root.email = val' v-bind="$root.emailAutoComplete">
              <input type="email" v-model="$root.email" class="customernew__field required" @keyup='checkEvent($event)' />
            </email-auto-complete>
        </label>
        <!--
        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">Bekräfta e-postadress <em>*</em></span>
          <input type="email" v-model="$root.email_confirm" class="customernew__field required" >
        </label>
        -->
        <label class="customernew__field-wrapper">
          <span class="customernew__field-label">Telefon <em>*</em></span>
          <input type="text" v-model="$root.phone" class="customernew__field required" >
        </label>

      </div>

      <div class="customernew__invoice-location">
        <!--<label class="checkbox">
          <input type="checkbox" class="checkbox__field" v-model="$root.invoice_address_same_as_property">
          <span class="checkbox__label">Fakturaadressen är samma som anläggningsadressen</span>
        </label>-->
        <div class="checkswitchrow">
          Fakturaadressen är samma som anläggningsadressen
          <div style="text-align:right;display:inline-block;">
          <label class="checkswitch">
            <input type="checkbox" v-model="$root.invoice_address_same_as_property">
            <span class="slider round"></span>
          </label>
          </div>
        </div>
        <div class="customernew__field-group" v-if="!$root.invoice_address_same_as_property">
          <label class="customernew__field-wrapper">
            <span class="customernew__field-label">Fakturaadress <em>*</em></span>
              <input type="text" v-model="$root.invoice_address" class="customernew__field required">
          </label>
            <label class="customernew__field-wrapper customernew__field-wrapper-third">
            <span class="customernew__field-label">Postnummer <em>*</em></span>
              <input type="text" v-model="$root.invoice_postal_code" class="customernew__field required">
          </label>
            <label class="customernew__field-wrapper customernew__field-wrapper-third">
            <span class="customernew__field-label">Postort <em>*</em></span>
              <input type="text" v-model="$root.invoice_location" class="customernew__field required">
          </label>
        </div>
      </div>

      <div class="step-nav">
        <button type="submit" class="button button--with-icon step-nav__button" v-on:click="$root.trackClickEvent('cta_kunduppgifter_steg5')">Fortsätt <Arrow /></button>
      </div>
    </form>
  </div>
</template>
<script>
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";

export default {

  components: {
    EmailAutoComplete
  },  
  mounted() {
        document.getElementsByClassName('customernew')[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

        let netPropertyKeyElement = document.getElementsByClassName('netpropertykey')[0];
        
        let curThis = this;

        netPropertyKeyElement.addEventListener('keyup', function (ev) {
                //console.log(ev);
                //console.log (netPropertyKeyElement);
                let txtVal = ev.target.value;

                /*
                if (txtVal.length >= 7 && txtVal.substr(7) == '735 999')
                  txtVal = txtVal.substr(7);
                else
                  txtVal = '';
                  */
                
                //let noText = "735999" + curThis.getNumberText(txtVal);
                let noText = curThis.getNumberText(txtVal);

                let newText = '';
                for (let i = 0; i < noText.length && i < 18; i++) {
                  newText += noText[i];
                  if ((i+1) % 3 == 0) {
                    newText += " ";
                  }
                }

                ev.target.value = newText.trim();
        });

        let netAreaCodeElement = document.getElementsByClassName('netareacode')[0];

        netAreaCodeElement.addEventListener('keyup', function (ev) {
          let txtVal = ev.target.value;
          
          let noText = curThis.getAlphaText(txtVal);
          let newText = '';

          for (let i = 0; i < noText.length && i < 3; i++) {
            newText += noText[i];
          }

          ev.target.value = newText.trim();

        });

      },  
  data() {
    return {
      emailAddress: '',
    }
  },
  methods: {
    getNumberText(txt) {
            if (!txt)
                return '';

            let s = '';

            for (let i = 0; i < txt.length; i++) {
                let c = txt[i];

                if (c >= '0' && c <= '9') {
                    s += c;
                }
            }

            return s;
        },
        getAlphaText(txt) {
            if (!txt)
                return '';

            let s = '';

            for (let i = 0; i < txt.length; i++) {
                let c = txt[i];

                if (
                  (c >= 'A' && c <= 'Z') ||
                  (c >= 'a' && c <= 'z') ||
                  (c == 'å' || c == 'ä' || c == 'ö') ||
                  (c == 'Å' || c == 'Ä' || c == 'Ö')
                 ) {
                    s += c;
                }
            }

            return s;
        },        
    checkEvent($event) {
      
      if ($event.target.value.indexOf('@') > 0) {
        let parts = $event.target.value.split('@');
        let domainPart = parts[1];

        //let ext = (domainPart != null && domainPart.length > 3) ? domainPart.substr(domainPart.length - 3) : '';

        //if (ext == ".se" || ext == ".com") {
        if (domainPart != null && (domainPart.endsWith('.se') || domainPart.endsWith('.com'))) {
          this.$root.emailAutoComplete.domains[12] = domainPart;
        }
        else
        {
          this.$root.emailAutoComplete.domains[12] = domainPart + '.se';
        }
      }

      // https://github.com/jameswylie/vue-email-autocomplete?ref=madewithvuejs.com
      this.$refs.EmailAutoComplete.check($event);

    },
    updateValidity(id, txt) {
            document.getElementById(id).setCustomValidity(txt);
            document.getElementById(id).checkValidity();
            document.getElementById(id).reportValidity();
            //document.getElementById(id).setCustomValidity('');
        },
	checkValidity(onlyUpdateIfValid) {
	
		if (!onlyUpdateIfValid)
			onlyUpdateIfValid = false;
			
		var r = true;
		
    var elements = document.querySelectorAll('.customernew INPUT');
		for (var i = 0; i < elements.length; i++) {
			var el = elements[i];
      let errorMessage = 'Fyll i det här fältet.';
			
			el.oninput = function (e) {
				e.target.setCustomValidity('');
			}
			
			var customCheck = true;
			var isRequired = true;
			
			if (el.className.indexOf('ssn') > 0) {
				this.$root.feedback.ssn = false;
				var ssnCheck = this.$root.validatePersonnummer(this.$root.personnummer);
				
				if (!ssnCheck) {
					this.$root.feedback.ssn = true;
					customCheck = false;
				}
			}
      else if (el.className.indexOf('netareacode') > 0) {
        if (!this.$root.territory_id || this.$root.territory_id.length != 3) {
          customCheck = false;
        }
      }
      else if (el.className.indexOf('netpropertykey') > 0) {
        let propKey = this.getNumberText(this.$root.construction_id);
        if (!propKey || propKey.length != 18) {
          customCheck = false;
          errorMessage = 'Du måste fylla i 18-siffror och det börjar på 735999.'
        }
      }
			
			if (el.className.indexOf('notrequired') > 0) {
				isRequired = false;
			}
			
			if (onlyUpdateIfValid) {
				if (el.value != '') {
					el.setCustomValidity('');
				}
			} else {
				el.setCustomValidity('');
				if (isRequired && (el.value == '' || !el.validity.valid || !customCheck)) {
					//console.log (el);
					el.setCustomValidity(errorMessage);
          el.checkValidity();
          el.reportValidity();
					r = false;
				}
			}
		}
		
		return r;
	},
    submit() {
      if (!this.checkValidity()) {
        return false;
      }

      this.$root.old_contract_description = '';
			
      //this.$router.push({ name: 'ordersummary' })
      this.$root.detailsShow = 'movingin';
      this.$root.flowString += 'customernew';
    },
    provider() {
        if(!this.$root.providing_cunstruction_and_territory_id) {
            this.$root.not_providing_cunstruction_and_territory_id = false;
        }else{
            this.$root.providing_cunstruction_and_territory_id = false;
        }
    }
  }
}
</script>
<style lang="scss">
  .uppgifter__anlaggning {
    margin-top: 35px;
    &__hidden {
      padding-top: 20px;
    }
    h3 {
      font-size: 18px;
    }
    &__subtitle {
      display: block;
      font-size: 18px;
      font-weight: bold;
    }
    &__field-wrapper {
      position: relative;
      display: block;
      margin-bottom: rem(16);
    }
    &__field-wrapper .info-circle {
      position: absolute;
      top: 60%;
      right: 5%;      
    }    
    &__field {
      position: absolute;
      opacity: 0;
    }
    &__field-content {
      border: 1px solid $light-border-color;
      border-radius: 3px;
      display: block;
    }
    &__field:focus + &__field-content,
    &__field-content:hover {
      border-color: $dark-border-color;
    }
    &__field:checked + &__field-content {
      border-color: $primary-color;
      border-width: 2px;
    }
    &__field-label {
      display: block;
      @include font-primary;
      font-size: rem(16);
      padding: rem(19);
      position: relative;
      em {
        font-style: normal;
        color: #c00;
      }
    }
    .info-circle {
      position: absolute;
      right: 15px;
      bottom: 7px;
      .tooltip {
        display: none;
      }
      &:hover .tooltip {
        display: block;
        left: -360px;
      }
    }
  }
  .customernew {
    &__title {
      text-align: center;
      margin: 0 0 rem(30);
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__block {
      margin-bottom: rem(40);
    }
    &__block-title {
      @include font-primary(bold);
      color: $secondary-text-color;
      font-size: rem(18);
      margin: 0 0 rem(15);
    }
    &__field-wrapper {
      margin-bottom: rem(24);
      font-size: rem(16);
      display: block;
      position: relative;
    }

    &__field-group {
      @include media('>lg') {
        display: flex;
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        justify-content: normal;
        align-items: flex-end;
      }
    }
    &__lookup {
        display: flex;
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        justify-content: normal;
        align-items: flex-end;
        .feedback {
            margin-top: -15px;
            margin-bottom: 20px;
        }
    }
    &__field-group &__field-wrapper {
      @include media('>lg') {
        flex-basis: calc(49% - #{rem(12)});
        margin-right: #{rem(12)};
      }
    }
    &__lookup &__field-wrapper {
      flex-basis: calc(49% - #{rem(12)});
    }
    &__field-group &__field-wrapper-third {
      @include media('>lg') {
        flex-basis: calc(24% - #{rem(12)}) !important;
        margin-right: #{rem(12)};
      }
    }
    &__field {
      @include unstyled-text-field;
      display: block;
      width: 100%;
      border: 1px solid $light-border-color;
      padding: #{(13/18)}em;
      &:focus,
      &:hover {
        border-color: $dark-border-color;
      }
      &::placeholder {
        color: $dark-border-color;
      }
    }
    &__field-label {
      @include font-primary;
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      display: block;
      &--title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        display: block;
        margin: 0 0 rem(9);
      }
      em {
        font-style: normal;
        color: #c00;
      }
    }
    &__lookup-submit {
      @include media('>lg') {
        flex: 1 1;
        margin: 0 0 rem(24) rem(24);
      }
      @include media('<=lg') {
        /*flex: 1 1;*/
        margin: 0 0 rem(24) 0;
      }
      font-size: rem(16);
      &[disabled], &:hover[disabled]{
        background-color: #fff;
      }
      .customernew__submit_text {
        display: block;
      }
      .customernew__submit_loader {
        display: none;
      }
      &.loading {
        padding: 9px 0 6px 0;
        .customernew__submit_text {
          display: none;
        }
        .customernew__submit_loader {
          display: block;
        }
      }
    }
    &__ids {
      margin-bottom: 1rem;
    }
    &__ids-text {
      @include font-primary(roman);
      font-size: rem(13);
      padding: rem(16);
      background-color: $light-bg-color;
      color: $secondary-text-color;
      text-align: center;
      border-radius: 4px;
      display: block;
      width: 100%;
      margin: 25px 0 10px 0;
    }
  }

</style>